import categoriesParser from "../util/categoriesParser";
export var pageLoadStarted = function pageLoadStarted(props) {
  var route = props.route;
  var location = window.location;
  var pageCategory = categoriesParser();
  var event = {
    event: "page_load_started",
    detailed_event: "Page Load Started",
    page_data: {
      hour_of_day: new Date().getHours(),
      language: navigator.language || navigator.userLanguage,
      page_id: route.itemId,
      page_title: route.fields && route.fields.MetaTitle && route.fields.MetaTitle.value,
      page_referrer: document.referrer,
      page_location: location.href,
      page_category: pageCategory[0],
      page_category2: pageCategory[1],
      page_category3: pageCategory[2],
      page_category4: pageCategory[3],
      page_category5: pageCategory[4]
    }
  };
  return event;
};